export default __webpack_public_path__ + "static/media/ux_explanation_20.f2293c6a.png";